module.exports = __webpack_public_path__ + "img/floor2_1.7d2ff43a.jpg";